/**
 * Created by lihanying on 2018/4/11.
 */
import React from 'react'
import { Input } from 'antd'

const InputGroup = (props) => {
  return (
    <div className="clubList_item">
      <span className="info-span">{props.title}:</span>
      <Input
        size="large"
        value={props.default}
        style={{ width: `${props.width}`, marginLeft: `${props.left}` }}
        placeholder={props.placeholder}
        disabled={props.disabled}
        onChange={(e) => props.dispatch(e.target.value)}
      />
      {props.children}
    </div>
  )
}
export default InputGroup



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/component/inputGroup.js